import { render, staticRenderFns } from "./physioEdit.vue?vue&type=template&id=7a3c188c&scoped=true"
import script from "./physioEdit.vue?vue&type=script&lang=js"
export * from "./physioEdit.vue?vue&type=script&lang=js"
import style0 from "./physioEdit.vue?vue&type=style&index=0&id=7a3c188c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c188c",
  null
  
)

export default component.exports